import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { League } from "@model";

export class TreeSelectItem {
  id?: number;
  name?: string;
  description?: string;
  selected: boolean = false;
  disabled: boolean = false;
  subItems?: TreeSelectItem[];
  tooltipMessage?: string;
  visible: boolean = true;
}

@Component({
  selector: 'tree-select-modal',
  templateUrl: './tree-select-modal.html',
  styleUrls: ['./tree-select-modal.scss'],
  standalone: false
})
export class TreeSelectModal implements OnInit {
  @Input({required: true}) title: string | undefined;
  @Input({required: true}) tableColumnName: string | undefined;
  @Input() items: TreeSelectItem[] | undefined;
  @Input() disabled: boolean = false;
  @Input() subItemCheckboxEnabled: boolean = true;
  filteredItems: TreeSelectItem[] | undefined = [];
  filteredInput: string = "";
  allHidden = true;

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
    if (this.items && this.items.length > 0) {
      this.filteredItems = [...this.items]
      this.filterItems(this.filteredInput, this.filteredItems);
    }
  }

  onSave(): Map<number, Set<number>> {
    const modalSelectedMap: Map<number, Set<number>> = new Map();

    (this.items ?? []).forEach(item => {
      if (item.selected) {
        const subItems = this.subItemCheckboxEnabled
            ? new Set(item.subItems?.filter(subItem => subItem.selected).map(r => r.id!) ?? [])
            : new Set<number>();

        modalSelectedMap.set(item.id!, subItems);
      }
    });

    this.activeModal.close(modalSelectedMap);

    return modalSelectedMap;
  }

  onDismissClick(): void {
    /// https://github.com/ng-bootstrap/ng-bootstrap/issues/3721
    this.activeModal.dismiss();
  }

  onItemChange(item: TreeSelectItem) {
    if (item.subItems) {
      for (const race of item.subItems) {
        race.selected = item.selected;
      }
    }
  }

  onSubItemChange(item: TreeSelectItem) {
    if (item.subItems) {
      item.selected = item.subItems.some(subItem => subItem.selected);
    }
  }

  handleSearchInput(value: string): void {
    this.filteredInput = value;
    if (this.items && this.items.length > 0) {
      this.filterItems(this.filteredInput, this.filteredItems);
    }
  }


  filterItems(filteredInput: string | undefined, items: TreeSelectItem[] | undefined) {
    if (!items) return;
    let allHidden = true;

    const lowerInput = filteredInput?.toLowerCase() ?? '';

    items.forEach((item: TreeSelectItem) => {
      if (item.subItems && this.subItemCheckboxEnabled) {
        this.filterItems(filteredInput, item.subItems);
      }

      const nameMatches = item.name?.toLowerCase().includes(lowerInput);
      const hasVisibleSubItems = item.subItems?.some(si => si.visible);

      item.visible = nameMatches || hasVisibleSubItems || !filteredInput;
      if (item.visible) {
        allHidden = false;
      }
    })
    this.allHidden = allHidden;
  }

}

